export const handleMouseDown = (action: () => void, componentRef: any) => {
  const handleMouseDown = (event: any) => {
    //@ts-ignore
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      action();
    }
  };
  document.addEventListener('mousedown', handleMouseDown);
  return () => document.removeEventListener('mousedown', handleMouseDown);
}